import React, { Component } from 'react';
import * as _ from 'lodash';
import { PermissionCheckbox } from './PermissionCheckbox';
import { permissionsToDisplay } from '../models/permissions';
import './PermissionCheckboxList.scss';

export class PermissionCheckboxList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            permissions: []
        };
    }

    isPermissionChecked = currentPermission => {
        return !!this.state.permissions.find(
            permission => currentPermission === permission
        );
    };

    handleTogglePermission = currentPermission => {
        const permissions = this.isPermissionChecked(currentPermission)
            ? this.state.permissions.filter(
                  permission => permission !== currentPermission
              )
            : [...this.state.permissions, currentPermission];

        this.setState(
            {
                ...this.state,
                permissions
            },
            () => this.onPermissionCheckboxChange()
        );
    };

    onPermissionCheckboxChange = () =>
        _.isFunction(this.props.onChange) &&
        this.props.onChange(this.state.permissions);

    render = () => (
        <div className={'permission-checkbox-list'}>
            {_.map(permissionsToDisplay, permission => (
                <PermissionCheckbox
                    key={permission}
                    permission={permission}
                    checked={this.isPermissionChecked(permission)}
                    onChange={() => this.handleTogglePermission(permission)}
                />
            ))}
        </div>
    );
}
